import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type {
  GridLoadingByCardColumnGap,
  GridLoadingByCardPadding,
  GridLoadingByCardRowGap,
  GridLoadingByCardTitleMargin,
} from './GridLoadingByCard.h'

import { Children } from 'react'
import { TextBox, TextBoxTypes } from 'atoms/TextBox'
import { useGridCardsCount } from 'blocks/Grid/hooks'
import { CardsInRow } from 'containers/RowContainer'
import {
  GridLoadingByCardColumnGaps,
  GridLoadingByCardRowGaps,
} from './GridLoadingByCard.h'
import {
  GridLoadingByCardSC,
  GridLoadingByCardWrapperSC,
} from './GridLoadingByCard.styled'

export interface IGridLoadingByCardProps {
  children: React.ReactNode
  content: object[]
  cardsInRow?: CardsInRow
  rowGap?: GridLoadingByCardRowGap
  columnGap?: GridLoadingByCardColumnGap
  title?: ITextBoxProps['title']
  colorTitle?: ITextBoxProps['color']
  fontTitle?: ITextBoxProps['font']
  maxLineTitle?: ITextBoxProps['maxLines']
  paddings?: GridLoadingByCardPadding
  marginTitle?: GridLoadingByCardTitleMargin
  tvChannelCard?: boolean
}

export const GridLoadingByCard = ({
  children,
  content,
  cardsInRow = CardsInRow.Horizontal_5,
  rowGap = GridLoadingByCardRowGaps.DEFAULT,
  columnGap = GridLoadingByCardColumnGaps.DEFAULT,
  title,
  colorTitle,
  fontTitle = TextBoxTypes.Headline3,
  maxLineTitle = 1,
  paddings,
  marginTitle,
  tvChannelCard = false,
}: IGridLoadingByCardProps): JSX.Element | null => {
  const cardsCount = useGridCardsCount(cardsInRow, tvChannelCard)

  return cardsCount && content?.length > 0 && Children.count(children) ? (
    <GridLoadingByCardWrapperSC paddings={paddings} marginTitle={marginTitle}>
      {title && (
        <TextBox
          color={colorTitle}
          maxLines={maxLineTitle}
          font={fontTitle}
          title={title}
        />
      )}
      <GridLoadingByCardSC
        rowGap={rowGap}
        columnGap={columnGap}
        cardsCount={cardsCount}
      >
        {children}
      </GridLoadingByCardSC>
    </GridLoadingByCardWrapperSC>
  ) : null
}
